import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const SECTIONS = [
  {
    id: "shipping", title: "Shipping & Delivery",
    qa: [
      ["How much is shipping for original paintings within Australia?", "Free. Original paintings ship free anywhere in Australia ($0.00 AUD). Each painting takes 2–3 business days for custom protective packing, followed by 2–6 business days standard transit via Australia Post or courier — a total estimated delivery of 4–9 business days."],
      ["Do you ship originals internationally?", "Yes. International orders use country-based tiered shipping rates plus insured transit, calculated at 1% of the painting's declared price. The exact shipping and insurance cost is shown at checkout before you pay."],
      ["How long do prints take to arrive?", "Canvas prints and fine art posters are printed on demand by our print partner, Gelato, at a facility close to you. Production takes 2–5 business days, followed by 3–5 business days local courier transit — a total estimated delivery of 5–10 business days worldwide."],
      ["Will I receive tracking details?", "Yes. You'll receive an email receipt as soon as your payment is confirmed, followed by tracking details once your artwork has been dispatched."],
    ],
  },
  {
    id: "returns", title: "Returns & Exchanges",
    qa: [
      ["Can I return an original painting?", "Original paintings are a final sale. Change-of-mind returns or exchanges are not accepted once a painting has been dispatched, in accordance with Australian Consumer Law. In the unlikely event that an original painting arrives damaged, a full refund or repair solution will be provided upon proof of delivery damage."],
      ["Can I return a print?", "On-demand prints are printed custom to order, so returns or exchanges for change of mind are not accepted. A full replacement or refund is guaranteed if a print arrives misprinted, defective, or damaged in transit."],
      ["What should I do if my artwork arrives damaged?", "Please keep all packaging and reply to your order confirmation email as soon as possible with photographs of the artwork and the packaging. We'll arrange a refund, repair or replacement as outlined above."],
      ["Does this affect my consumer rights?", "No. Nothing in these policies excludes or limits your rights under the Australian Consumer Law."],
    ],
  },
  {
    id: "authenticity", title: "Artwork Authenticity",
    qa: [
      ["Are the original paintings one of a kind?", "Yes. Each original is a unique, hand-painted work by Laszlo Abonyi. Once it sells, it is marked SOLD in the collection and cannot be purchased again."],
      ["Are originals signed?", "Every original painting is signed by the artist. Each listing includes a close-up photograph of the signature alongside a surface detail shot."],
      ["What are the prints made from?", "Prints are reproduced from high-resolution 300 DPI master files of the original paintings, printed either on stretched canvas over a slim wooden frame or on fine art poster paper."],
      ["Do original paintings come framed?", "No. All original paintings are sold unframed, as-is."],
    ],
  },
  {
    id: "care", title: "Care Instructions",
    qa: [
      ["How should I hang and display an original painting?", "Hang away from direct sunlight, radiators, fireplaces and damp walls. Stable temperature and humidity help keep oil paint and canvas in the best condition for decades."],
      ["How do I clean a painting?", "Dust gently with a soft, dry brush or microfibre cloth. Never use water, household cleaners or solvents on the painted surface."],
      ["How should I care for prints?", "Canvas prints can be dusted with a soft dry cloth. Fine art posters are best framed behind glass or acrylic and kept out of direct sunlight to prevent fading."],
      ["How should I handle artwork?", "Handle canvases by the stretcher bars or edges with clean, dry hands, and avoid pressing on the front or back of the canvas."],
    ],
  },
];

export default function Faq() {
  return (
    <div className="container-x py-16 sm:py-24" data-testid="faq-page">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">Information</p>
          <h1 className="mt-6 font-display text-5xl font-light leading-tight sm:text-6xl">Questions & store policies</h1>
          <nav className="mt-12 hidden flex-col gap-3 lg:flex">
            {SECTIONS.map((s) => (
              <a key={s.id} href={`#${s.id}`} className="text-sm text-[#5A626A] transition-colors hover:text-[#1A1A1A]" data-testid={`faq-jump-${s.id}`}>{s.title}</a>
            ))}
          </nav>
        </div>
        <div className="space-y-20 lg:col-span-8">
          {SECTIONS.map((s) => (
            <section key={s.id} id={s.id} className="scroll-mt-28" data-testid={`faq-section-${s.id}`}>
              <h2 className="font-display text-3xl font-light">{s.title}</h2>
              <Accordion type="multiple" className="mt-6 border-t border-[#E5E0D8]">
                {s.qa.map(([q, a], i) => (
                  <AccordionItem key={q} value={`${s.id}-${i}`} className="border-[#E5E0D8]">
                    <AccordionTrigger data-testid={`faq-trigger-${s.id}-${i}`} className="py-6 text-left text-[15px] font-normal hover:no-underline">{q}</AccordionTrigger>
                    <AccordionContent className="pb-6 text-[15px] leading-[1.8] text-[#5A626A]">{a}</AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
